import React from "react";
import { motion } from "framer-motion";
import { IMAGES } from "../lib/images";
import { TIMELINE } from "../lib/timeline";
import { Reveal, useSEO } from "../components/site/Reveal";
import Newsletter from "../components/site/Newsletter";

export default function HistoryTimeline() {
  useSEO(
    "Yorùbá History Timeline",
    "A timeline of Yorùbá history — from the creation myth at Ilé-Ifẹ̀ and the Ọ̀yọ́ Empire to the diaspora and the global Yorùbá culture of today."
  );

  return (
    <div>
      <header className="relative min-h-[52vh] flex items-end grain-overlay">
        <div className="absolute inset-0">
          <img src={IMAGES.durbarHorses} alt="Ancient Ilé-Ifẹ̀ bronze and terracotta heads of Yorùbá antiquity" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-night via-night/70 to-night/40" />
        </div>
        <div className="relative max-w-5xl mx-auto px-6 pb-16 w-full">
          <p className="uppercase tracking-[0.3em] text-xs text-gold-soft mb-5">Deep Knowledge</p>
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            className="font-serif text-5xl lg:text-6xl text-cream leading-tight text-shadow-hero"
          >
            Yorùbá History Timeline
          </motion.h1>
        </div>
      </header>

      <section className="max-w-4xl mx-auto px-6 py-24">
        <div className="relative border-l-2 border-parchment ml-3 md:ml-0 md:pl-0">
          {TIMELINE.map((t, i) => (
            <Reveal key={t.title} delay={0.04}>
              <div className="relative pl-8 md:pl-12 pb-14 last:pb-0" data-testid={`timeline-item-${i}`}>
                <span className="absolute -left-[9px] top-1.5 w-4 h-4 rounded-full bg-gold ring-4 ring-cream" />
                <p className="text-xs uppercase tracking-[0.2em] text-gold font-semibold mb-2">
                  {t.era}
                </p>
                <h2 className="font-serif text-2xl md:text-3xl text-ink mb-3">{t.title}</h2>
                <p className="text-lg text-ink-muted leading-relaxed">{t.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <Newsletter />
    </div>
  );
}
